import React from "react";
import { Button } from "./ui/ui/button";
import { MapPin, Clock, Terminal } from "lucide-react";
import logo from "../assets/hackai_logo_nobg_trim.png";

const Hero: React.FC = () => {

  return (
    <div className="min-h-screen flex flex-col justify-center items-center px-4 py-20">
      <div className="container max-w-4xl mx-auto text-center space-y-12">
        {/* Logo and Title */}
        <div className="space-y-6">
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 rounded-full blur-md animate-pulse" />
              <img
                src={logo}
                alt="HackAI Logo"
                className="relative h-20 w-20 object-contain"
              />
            </div>
          </div>
          
          <div className="space-y-4">
            <h1 className="text-5xl lg:text-7xl font-bold font-mono text-primary">
              HACK_AI
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Where Austin's AI builders connect, learn, and grow together
            </p>
          </div>
        </div>

        {/* Event Details */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-sm">
          <div className="flex items-center space-x-2">
            <Clock className="h-4 w-4 text-primary" />
            <span className="text-foreground">July 10th • 6:00-8:00pm</span>
          </div>
          <div className="hidden sm:block text-muted-foreground">|</div>
          <div className="flex items-center space-x-2">
            <MapPin className="h-4 w-4 text-primary" />
            <span className="text-foreground">1705 Guadalupe St. at DeAI Office</span>
          </div>
        </div>


        {/* CTA */}
        <div className="space-y-4">
          <Button 
            asChild
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-base px-8"
          >
            <a 
              href="https://lu.ma/hackai-techparty" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center"
            >
              <Terminal className="h-4 w-4 mr-2" />
              ./register --luma
            </a>
          </Button>
          <p className="text-xs text-muted-foreground">
            Free event • All developers welcome
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;